export default __webpack_public_path__ + "static/media/pipedrive.bff15181.svg";